import {
  Box,
  Flex,
  HStack,
  Text,
  Button,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { RepeatIcon } from '@chakra-ui/icons';
import { IoWarningOutline } from 'react-icons/io5';
import MVRStatusBadge from 'components/mvr/MVRStatusBadge';

import type { MVRErrorDetails } from 'api/quote-marketplace';

interface MVRErrorAlertProps {
  errorDetails: MVRErrorDetails;
  canRetry: boolean;
  onRetry: () => void;
  isRetrying: boolean;
}

const MVRErrorAlert = ({
  errorDetails,
  canRetry,
  onRetry,
  isRetrying,
}: MVRErrorAlertProps) => {
  const bg = useColorModeValue('orange.50', 'rgba(251, 211, 141, 0.1)');
  const borderColor = useColorModeValue('orange.200', 'orange.700');
  const iconColor = useColorModeValue('orange.500', 'orange.300');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const mutedColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Box
      bg={bg}
      border="1px solid"
      borderColor={borderColor}
      borderRadius="lg"
      p={4}
    >
      <Flex justify="space-between" align="flex-start" gap={4}>
        <HStack align="flex-start" spacing={3}>
          <Icon as={IoWarningOutline} boxSize={5} color={iconColor} mt={0.5} />
          <Box>
            <Text fontWeight="600" color={textColor} mb={1}>
              MVR Verification Incomplete
            </Text>
            <Text fontSize="sm" color={mutedColor} mb={3}>
              {errorDetails.summary_message}
            </Text>

            {errorDetails.driver_statuses.length > 0 && (
              <HStack spacing={3} flexWrap="wrap">
                {errorDetails.driver_statuses.map((driver, idx) => (
                  <HStack key={idx} spacing={2}>
                    <Text fontSize="sm" color={textColor}>
                      {driver.driver_name}
                    </Text>
                    <MVRStatusBadge status={driver.status} />
                  </HStack>
                ))}
              </HStack>
            )}
          </Box>
        </HStack>

        {canRetry && (
          <Button
            size="sm"
            variant="outline"
            colorScheme="orange"
            leftIcon={<RepeatIcon />}
            onClick={onRetry}
            isLoading={isRetrying}
            loadingText="Retrying"
            flexShrink={0}
          >
            Retry
          </Button>
        )}
      </Flex>
    </Box>
  );
};

export default MVRErrorAlert;
